module.exports = [{
      plugin: require('/Users/wilmer/dev/sdtech-hub/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography.js"},
    },{
      plugin: require('/Users/wilmer/dev/sdtech-hub/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-132434434-1"},
    },{
      plugin: require('/Users/wilmer/dev/sdtech-hub/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
